import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateCouncilMember.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import memberAdded from '../../../../assets/Imagess/member-added.png';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import { useFetchAcademicYears } from '../../../../Hooks/Settings';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import { useFetchCouncilCalendarById } from '../../../../Hooks/Council';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import Loader from '../../../Molecules/Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';

const CreateCouncilCalendar = () => {
  const { id } = useParams();
  const customizedToast = useToast();
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const fileInputRef4 = useRef(null);
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const [imageSrc, setImageSrc] = useState('');
  const [imageSrc2, setImageSrc2] = useState('');
  const [imageSrc3, setImageSrc3] = useState('');
  const [imageSrc4, setImageSrc4] = useState('');
  const { data: years } = useFetchAcademicYears();
  const { data, isLoading, refetch } = useFetchCouncilCalendarById(id);

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      formikRef.current.setValues({
        academicYear: data?.data?.academicYear?.acadamicYearId,
      });
      setImageSrc(
        sanitizeAndValidateUrl(
          `${data?.data?.url}${data?.data?.studentCalendar}`
        )
      );
      setImageSrc2(
        sanitizeAndValidateUrl(
          `${data?.data?.url}${data?.data?.parentCalendar}`
        )
      );
      setImageSrc3(
        sanitizeAndValidateUrl(`${data?.data?.url}${data?.data?.cadetCalendar}`)
      );
      setImageSrc4(
        sanitizeAndValidateUrl(
          `${data?.data?.url}${data?.data?.facultyCalendar}`
        )
      );
    }
  }, [data]);

  const validationSchema = Yup.object().shape({
    academicYear: Yup.string().required('Academic Year is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Student Calendar is required'),
    image2:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Parent Calendar is required'),
    image3:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Cadet Calendar is required'),
    image4:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Faculty Calendar is required'),
  });

  const createCalendar = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Council/CouncilCalendar`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث تقويم المجلس بنجاح ' : 'تم إنشاء تقويم المجلس بنجاح '
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    const calendarId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('CouncilCalendarId', calendarId);
    formData.append('AcadmicYearId', values.academicYear);
    if (undefined !== values.image) {
      formData.append('StudentCalendar', values.image);
    }
    if (undefined !== values.image2) {
      formData.append('ParentCalendar', values.image2);
    }
    if (undefined !== values.image3) {
      formData.append('CadetCalendar', values.image3);
    }
    if (undefined !== values.image4) {
      formData.append('FacultyCalendar', values.image4);
    }
    createCalendar.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تحديث التقويم' : 'إضافة تقويم جديد'}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            academicYear: data?.data?.academicYear?.acadamicYearId || '',
            image: null,
            image2: null,
            image3: null,
            image4: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['steps']}>
                <div className={styles['step-container']}>
                  <CustomSelect
                    label='Years'
                    placeholder='Select Year'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ height: '62px', marginTop: '4px' }}
                    value={values.academicYear}
                    onChange={(e) => setFieldValue('academicYear', e.value)}
                    options={years?.data?.map((option) => ({
                      value: option.acadamicYearId,
                      text: option.academicName,
                    }))}
                    errors={errors.academicYear}
                    touched={errors.academicYear}
                  />
                </div>
              </div>
              <p
                style={{
                  marginTop: '30px',
                  fontSize: '16px',
                  color: '#000',
                  fontFamily: 'BukraMedium',
                }}
              >
                Upload Students Council Calendar
              </p>
              {errors.image && (
                <div className={styles['error-message']}>
                  <p style={{ marginTop: '5px !important' }}>{errors.image}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef.current.click()}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) =>
                    setFieldValue('image', event.currentTarget.files[0])
                  }
                />
                {values.image ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <p
                style={{
                  marginTop: '30px',
                  fontSize: '16px',
                  color: '#000',
                  fontFamily: 'BukraMedium',
                }}
              >
                Upload Parents Council Calendar
              </p>
              {errors.image2 && (
                <div className={styles['error-message']}>
                  <p>{errors.image2}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef2.current.click()}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef2}
                  onChange={(event) =>
                    setFieldValue('image2', event.currentTarget.files[0])
                  }
                />
                {values.image2 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image2)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc2 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc2}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <p
                style={{
                  marginTop: '30px',
                  fontSize: '16px',
                  color: '#000',
                  fontFamily: 'BukraMedium',
                }}
              >
                Upload Cadets Council Calendar
              </p>
              {errors.image3 && (
                <div className={styles['error-message']}>
                  <p>{errors.image3}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef3.current.click()}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  accept='image/*'
                  ref={fileInputRef3}
                  onChange={(event) =>
                    setFieldValue('image3', event.currentTarget.files[0])
                  }
                />
                {values.image3 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image3)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc3 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc3}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <p
                style={{
                  marginTop: '30px',
                  fontSize: '16px',
                  color: '#000',
                  fontFamily: 'BukraMedium',
                }}
              >
                Upload Faculty Council Calendar
              </p>
              {errors.image4 && (
                <div className={styles['error-message']}>
                  <p>{errors.image4}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef4.current.click()}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef4}
                  onChange={(event) =>
                    setFieldValue('image4', event.currentTarget.files[0])
                  }
                />
                {values.image4 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image4)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc4 ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc4}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateCouncilCalendar;
